import {monolithPost} from './fetch'
import {camelCaseObjectKeys, onStatus, shimJson} from './helpers'

/**
 * Validate any address using UPS Validation. Returns `200` for all validation
 * states of an address.
 *
 * @param {Object} payload An object of address pieces to validate
 * @param {String} payload.address1 The first line of the address
 * @param {String} payload.address2 The second line of the address
 * @param {String} payload.city The city
 * @param {String} payload.state The state
 * @param {String} payload.zip The zip code
 * @returns {Promise} Returns a camel-cased server response upon success
 */
export const validateAddress = ({address1, address2, city, state, zip}) =>
  monolithPost('/ajax/v2/validate-address', {
    Line1: address1,
    Line2: address2,
    Region: state,
    City: city,
    PostalCode: zip,
  }).then(
    onStatus({
      OK: shimJson(camelCaseObjectKeys),
    }),
  )
